import { style } from "@angular/animations";
import { Component, HostListener, OnInit } from "@angular/core";
import { ColDef, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import moment from 'moment'
//import * as momentTimezone from "moment-timezone";

import momentTimezone from "moment-timezone";
import { ClipboardService } from "ngx-clipboard";
import { ToastrService } from "ngx-toastr";

@Component({
  template: '',
  standalone: false
})
export class AgGridExtension {

  columnDefs: ColDef[]

  gridApi
  gridColumnApi
  gridOptions

  sizeingMode = SIZING_MODE.MAX

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.autoSizeAll();
  }

  onGridReady(params: GridReadyEvent) {
    //console.log(this.onGridReady)
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeAll();
  }

  sizeColumnsToFit() {
    this.gridApi.sizeColumnsToFit()
  }


  autoSizeAll(skipHeader = false) {

    setTimeout(() => {

      if (this.sizeingMode == SIZING_MODE.MAX) {
        this.sizeColumnsToFit()
      } else {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().filter(e => e.colDef.resizable).forEach((column) => {
          allColumnIds.push(column.colId);
        });

        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
      }

    }, 50);


  }

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    suppressMovable: true,
    suppressToolPanel: true,
  };

}



@Component({
  selector: 'app-grid-edit',
  template: '<i class="ft-edit info" (click)="btnClickedHandler($event)" container="body" ngbTooltip="Modifica"></i>',
  standalone: false
})
export class GridEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

}

@Component({
  selector: 'app-grid-link',
  template: '<i class="ft-link" (click)="btnClickedHandler($event)" container="body" ngbTooltip="link"></i>',
  standalone: false
})
export class GridLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

}

@Component({
  selector: 'app-grid-edit',
  template: '<i class="ft-layers success" (click)="btnClickedHandler($event)" container="body" ngbTooltip="Duplica"></i>',
  standalone: false
})
export class GridCloneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

}


@Component({
  selector: 'app-grid-quiz',
  template: `<div class="cnt"> <i *ngIf="this.params.value=='Promosso'" [ngClass]="'ft-check ' + getColor(this.params.value)" container="body" [ngbTooltip]="this.params.value"></i> <i *ngIf="this.params.value=='Rimandato'"  [ngClass]="'ft-x ' + getColor(this.params.value)" container="body" [ngbTooltip]="this.params.value"></i></div>`,
  styles: [
    `.cnt { width:100%; text-align:center }
    .nopadding {margin:0; padding:0}`
  ],
  standalone: false
})
export class GridQuizComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

  getColor(value) {
    switch (value) {
      case 'Promosso': return 'success'
      case 'Rimandato': return 'danger'
      case 'Non presenti': return 'success'
      default: return 'light'
    }
  }

}



@Component({
  selector: 'app-grid-online-offline',
  template: `<div class="cnt nopadding"  container="body" [ngbTooltip]="this.params.value">  
                <i class="icon-screen-desktop" *ngIf="online"></i>
                <span *ngIf="online && offline" >&nbsp;</span>
                <i class="icon-users" *ngIf="offline"></i>
            </div>`,
  styles: [
    `.cnt { width:100%; text-align:center }`
  ],
  standalone: false
})
export class GridOnlineOffline implements OnInit {

  online = false
  offline = false

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;

    switch (this.params.value) {
      case 'online': this.online = true; break;
      case 'presenza': this.offline = true; break;
      default:
        this.online = true;
        this.offline = true;
    }

  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

  getColor(value) {
    switch (value) {
      case 'Promosso': return 'success'
      case 'Rimandato': return 'danger'
      default: return 'light'
    }
  }

}


@Component({
  selector: 'app-grid-copyurl',
  template: `<i class="ft-external-link" *ngIf="params?.value && params.value != ''"  (click)="btnClickedHandler($event)" container="body" ngbTooltip="Copia indirizzo"></i>`,
  standalone: false
})
export class GridCopyURLComponent implements OnInit {

  constructor(private clipboard: ClipboardService, private toastr: ToastrService) { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {

    this.clipboard.copy(this.params.value)

    this.toastr.info("L'indirizzo è stato copiato nella clipboard!", 'Attenzione!');

  }

}

@Component({
  selector: 'app-grid-delete',
  template: '<i class="ft-trash danger"   (click)="btnClickedHandler($event)" container="body" ngbTooltip="Elimina"></i>',
  standalone: false
})
export class GridDeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }
  btnClickedHandler(e) {
    this.params.clicked(this.params.value);
  }

}




@Component({
  selector: 'app-grid-progress',
  template: `
   <ngb-progressbar class="vertical-center" showValue="true" type="success" [value]="params.value" ></ngb-progressbar> 
  `,
  styles: [`
    .vertical-center {
      margin: 0;
      position: absolute;
      top: 50%;
      left:3px;
      right:3px;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }`
  ],
  standalone: false
})
export class GridProgressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }

}

@Component({
  selector: 'app-grid-toggle',
  template: `

  <div class="custom-switch  mb-1 mb-xl-0" style="margin-top:10px" (click)="onClick()">
    <label class="custom-control-label mr-1" for="custom-switch-1"></label>
  </div>


  `,
  standalone: false
})
export class GridToggleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  agInit(params: any) {
    this.params = params;
  }

  onClick() {
    this.params.value = !this.params.value
    this.params.clicked(this.params);
  }



}








@Component({
  selector: 'app-image-formatter-cell',
  template: `<img *ngIf="params.value" border="0"  style="display:block; margin:auto; height: 35px" src=\"{{ params.value }}\" class="users-avatar avatar  rounded-circle">`,
  standalone: false
})

export class GridImageFormatterComponent {
  params: any;
  agInit(params: any) {
    this.params = params;
  }
}

export const SIZING_MODE = {
  MAX: 'MAX',
  FIT: 'FIT'
}

export const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  const dateAsString = cellValue;

  if (dateAsString == null) {
    return 0;
  }

  let cellDate = new Date(dateAsString)

  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
}

export const dateTimeFormatterTZ = (d, format = 'DD/MM/YYYY HH:mm') => {

  try {
    return momentTimezone(d.value + 'Z').tz('Europe/Rome').format(format)
  } catch (error) { }

}

export const dateFormatter = (d, format = 'DD/MM/YYYY') => {

  try {
    return moment(d.value.substring(0, 10)).format(format)
  } catch (error) { }

}
export const dateTimeFormatter = (d) => {

  try {
    return moment(d.value).format('DD/MM/YYYY HH:mm')
  } catch (error) { }

}
export const timeFormatter = (d) => {
  try {

    return moment(d.value).format('HH:mm')
  } catch (error) { }
}
export const durationFormatter = (d) => {

  try {
    let dd = new Date()
    dd.setTime(+d.value * 1000)
    return moment.utc(dd).format('HH:mm:ss')
  } catch (error) { }

}



export const AG_GRID_LOCALE_IT = {
  // Set Filter
  selectAll: '(Seleziona Tutti)',
  selectAllSearchResults: '(Seleziona Tutti I Risultati Di Ricerca)',
  searchOoo: 'Cerca...',
  blanks: '(Vuoto)',
  noMatches: 'Nessun incontro',

  // Number Filter & Text Filter
  filterOoo: 'Filtro...',
  equals: 'Uguale',
  notEqual: 'Diverso',
  blank: 'Vuoto',
  notBlank: 'Non Vuoto',
  empty: 'Scegli Uno',

  // Number Filter
  lessThan: 'Minore di',
  greaterThan: 'Maggiore di',
  lessThanOrEqual: 'Minore o uguale di',
  greaterThanOrEqual: 'Maggiore o uguale di',
  inRange: 'Contenuto in',
  inRangeStart: 'da',
  inRangeEnd: 'a',

  // Text Filter
  contains: 'Contiene',
  notContains: 'Non contiene',
  startsWith: 'Inizia con',
  endsWith: 'Finisce con',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'E',
  orCondition: 'O',

  // Filter Buttons
  applyFilter: 'Applica',
  resetFilter: 'Resetta',
  clearFilter: 'Pulisci',
  cancelFilter: 'Annulla',

  // Filter Titles
  textFilter: 'Filtro Testo',
  numberFilter: 'Filtro Numerico',
  dateFilter: 'Filtro Data',
  setFilter: 'Filtro Elenco',

  // Side Bar
  columns: 'Colonne',
  filters: 'Filtri',

  // columns tool panel
  pivotMode: 'Mod. Pivot',
  groups: 'Row Groups',
  rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
  values: 'Values',
  valueColumnsEmptyMessage: 'Drag here to aggregate',
  pivots: 'Column Labels',
  pivotColumnsEmptyMessage: 'Drag here to set column labels',

  // Header of the Default Group Column
  group: 'Group',

  // Row Drag
  rowDragRows: 'rows',

  // Other
  loadingOoo: 'Loading...',
  noRowsToShow: 'No Rows To Show',
  enabled: 'Enabled',

  // Menu
  pinColumn: 'Pin Column',
  pinLeft: 'Pin Left',
  pinRight: 'Pin Right',
  noPin: 'No Pin',
  valueAggregation: 'Value Aggregation',
  autosizeThiscolumn: 'Autosize This Column',
  autosizeAllColumns: 'Autosize All Columns',
  groupBy: 'Group by',
  ungroupBy: 'Un-Group by',
  addToValues: 'Add ${variable} to values',
  removeFromValues: 'Remove ${variable} from values',
  addToLabels: 'Add ${variable} to labels',
  removeFromLabels: 'Remove ${variable} from labels',
  resetColumns: 'Reset Columns',
  expandAll: 'Expand All',
  collapseAll: 'Close All',
  copy: 'Copy',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copy With Headers',
  copyWithHeaderGroups: 'Copy With Header Groups',
  paste: 'Paste',
  ctrlV: 'Ctrl+V',
  export: 'Export',
  csvExport: 'CSV Export',
  excelExport: 'Excel Export',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Average',
  filteredRows: 'Filtered',
  selectedRows: 'Selected',
  totalRows: 'Total Rows',
  totalAndFilteredRows: 'Rows',
  more: 'More',
  to: 'to',
  of: 'of',
  page: 'Page',
  nextPage: 'Next Page',
  lastPage: 'Last Page',
  firstPage: 'First Page',
  previousPage: 'Previous Page',

  // Pivoting
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  combinationChart: 'Combination',
  columnLineCombo: 'Column & Line',
  AreaColumnCombo: 'Area & Column',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  combinationGroup: 'Combination',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Column & Line',
  areaColumnComboTooltip: 'Area & Column',
  customComboTooltip: 'Custom Combination',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',
  seriesChartType: 'Series Chart Type',
  seriesType: 'Series Type',
  secondaryAxis: 'Secondary Axis',

  // ARIA
  ariaHidden: 'hidden',
  ariaVisible: 'visible',
  ariaChecked: 'checked',
  ariaUnchecked: 'unchecked',
  ariaIndeterminate: 'indeterminate',
  ariaDefaultListName: 'List',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterList: 'Filter List',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumn: 'Column',
  ariaColumnList: 'Column List',
  ariaColumnGroup: 'Column Group',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaToggleVisibility: 'Press SPACE to toggle visibility',
  ariaSearch: 'Search',
  ariaSearchFilterValues: 'Search filter values',

  ariaRowGroupDropZonePanelLabel: 'Row Groups',
  ariaValuesDropZonePanelLabel: 'Values',
  ariaPivotDropZonePanelLabel: 'Column Labels',
  ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
  ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Column Menu',
  ariaLabelCellEditor: 'Cell Editor',
  ariaLabelDialog: 'Dialog',
  ariaLabelSelectField: 'Select Field',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Context Menu',
  ariaLabelSubMenu: 'SubMenu',
  ariaLabelAggregationFunction: 'Aggregation Function',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.'

}


export const AG_GRID_LOCALE_ZZZ = {};

// Create a dummy locale bad on english but prefix everything with zzz
Object.keys(AG_GRID_LOCALE_IT).forEach(function (key) {
  if (key === 'thousandSeparator' || key === 'decimalSeparator') {
    return;
  }
  AG_GRID_LOCALE_ZZZ[key] = 'zzz-' + AG_GRID_LOCALE_IT[key];
});
